import { RtmpDestinationV2EntityRaw } from "@common/domain";
import { EntityState, EntityAdapter, createEntityAdapter } from "@ngrx/entity";
import { createReducer, on, Action } from "@ngrx/store";
import { DestinationsActions } from "../actions";

export const RTMP_DESTINATIONS_FEATURE_KEY = "rtmp-destinations";

export interface RtmpDestinationsState
  extends EntityState<RtmpDestinationV2EntityRaw> {
  isLoading: boolean;
}

export const destinationsAdapter: EntityAdapter<RtmpDestinationV2EntityRaw> =
  createEntityAdapter<RtmpDestinationV2EntityRaw>({
    selectId: (_) => _.id,
    sortComparer: (lhs, rhs) => rhs.updatedAt - lhs.updatedAt
  });

export const initialDestinationsState: RtmpDestinationsState =
  destinationsAdapter.getInitialState({
    isLoading: false
  });

const reducer = createReducer(
  initialDestinationsState,
  on(
    DestinationsActions.loadRtmpDestinations,
    DestinationsActions.addRtmpDestination,
    DestinationsActions.updateRtmpDestination,
    DestinationsActions.deleteRtmpDestination,
    (state) => ({
      ...state,
      isLoading: true
    })
  ),
  on(DestinationsActions.loadRtmpDestinationsFailure, () =>
    destinationsAdapter.removeAll({
      ...initialDestinationsState,
      isLoading: false
    })
  ),
  on(
    DestinationsActions.addRtmpDestinationFailure,
    DestinationsActions.updateRtmpDestinationFailure,
    DestinationsActions.deleteRtmpDestinationFailure,
    DestinationsActions.updateRtmpDestinationCancel,
    DestinationsActions.deleteRtmpDestinationCancel,
    (state) => ({
      ...state,
      isLoading: false
    })
  ),
  on(
    DestinationsActions.loadRtmpDestinationsSuccess,
    (state, { destinations }) =>
      destinationsAdapter.setAll(
        destinations.map((_) => _.toJSON()),
        {
          ...state,
          isLoading: false
        }
      )
  ),
  on(
    DestinationsActions.addRtmpDestinationSuccess,
    DestinationsActions.updateRtmpDestinationSuccess,
    (state, action) =>
      destinationsAdapter.setOne(action.destination.toJSON(), {
        ...state,
        isLoading: false
      })
  ),
  on(DestinationsActions.deleteRtmpDestinationSuccess, (state, action) =>
    destinationsAdapter.removeOne(action.id, {
      ...state,
      isLoading: false
    })
  )
);

export function rtmpDestinationsReducer(
  state: RtmpDestinationsState | undefined,
  action: Action
) {
  return reducer(state, action);
}
